import { Injectable } from '@angular/core';
import { MessageService } from '@services/message.service';
import {
  AccountLockedError,
  AccountPendingActivationError,
  AccountSuspendedError,
  ConnectionError,
  SSOAccountNotFound,
  SSOError,
  SSOLoginError,
  SuperAccountPendingError,
  TechnicalUserCannotLoginToUIError,
  WrongEmailOrPasswordError,
} from '@repository/authentication/models/errors.model';
import { TimeoutError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthErrorHandlerService {
  public constructor(private readonly messageService: MessageService) {}

  public present(error: unknown): void {
    if (error instanceof SuperAccountPendingError) {
      this.messageService.showWarningMessage('authentication.super_user_account_pending');
      return;
    }

    if (error instanceof WrongEmailOrPasswordError) {
      this.messageService.showErrorMessage('authentication.wrong_email_or_password');
      return;
    }

    if (error instanceof AccountLockedError) {
      this.messageService.showErrorMessage('authentication.account_locked');
      return;
    }

    if (error instanceof AccountPendingActivationError) {
      this.messageService.showErrorMessage('authentication.account_pending_activation');
      return;
    }

    if (error instanceof AccountSuspendedError) {
      this.messageService.showErrorMessage('authentication.account_suspended');
      return;
    }

    if (error instanceof TechnicalUserCannotLoginToUIError) {
      this.messageService.showErrorMessage('authentication.technical_user_cannot_login_to_ui');
      return;
    }

    if (error instanceof ConnectionError || error instanceof TimeoutError) {
      this.messageService.showErrorMessage('general.backend_not_running');
      return;
    }

    if (error instanceof SSOError) {
      this.messageService.showErrorMessage('authentication.sso_error');
      return;
    }

    if (error instanceof SSOAccountNotFound) {
      this.messageService.showErrorMessage('authentication.sso_user_not_found');
      return;
    }

    if (error instanceof SSOLoginError) {
      this.messageService.showErrorMessage('authentication.sso_login_error');
    }
  }
}
